import { Component, OnInit, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ShouldDisplaySoilAnalysisCharacteristicAbbreviation } from '@next/arable-lib/shared';
import {
  AbstractDialog,
  AbstractDialogData,
  AbstractDialogResultData,
} from '@next/core-lib/dialog';
import { SoilAnalysis } from 'src/app/shared/models';

interface SoilAnalysisCompleteViewDialogModel extends AbstractDialogData {
  soilAnalysis: SoilAnalysis;
}

@Component({
  selector: 'app-soil-analysis-complete-view-dialog',
  templateUrl: './soil-analysis-complete-view-dialog.component.html',
  styleUrls: ['./soil-analysis-complete-view-dialog.component.scss'],
  standalone: false,
})
export class SoilAnalysisCompleteViewDialogComponent extends AbstractDialog implements OnInit {
  protected mdDialogRef = inject<MatDialogRef<SoilAnalysisCompleteViewDialogComponent, AbstractDialogResultData>>(MatDialogRef);
  data = inject<SoilAnalysisCompleteViewDialogModel>(MAT_DIALOG_DATA);

  displayedColumns: string[] = ['designation', 'value'];
  shouldDisplaySoilAnalysisCharacteristicAbbreviation =
    ShouldDisplaySoilAnalysisCharacteristicAbbreviation;

  ngOnInit(): void {
    this.showTargetValuesColumn();
  }

  targetValuesHasBothMinAndMax = (targetValues: { minimum: number; maximum: number }) =>
    targetValues.minimum * targetValues.maximum !== 0;

  isWithinTargetValues = (value: number, targetValues: { minimum: number; maximum: number }) =>
    targetValues.minimum <= value && value <= (targetValues.maximum || Number.MAX_SAFE_INTEGER);

  private showTargetValuesColumn() {
    const targetValuesSampledCharacteristic = this.data.soilAnalysis.sampledCharacteristics.some(
      (sampledCharacteristic) => sampledCharacteristic.targetValues,
    );
    if (targetValuesSampledCharacteristic) {
      this.displayedColumns.push('targetValues');
    }
  }
}
